import styled from 'styled-components';

export const Container = styled.div`
  width: 420px;
  max-width: 90vw;
  border: 1px solid var(--primary);
  background: var(--background);
  color: var(--primary);
  border-radius: 10px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  header {
    width: 100%;
    display: flex;
    align-items: center;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid #c8ded8;

    h1 {
      flex: 1;
      font-size: 1.25rem;
      font-weight: 700;
      color: var(--primary);
      text-align: center;
    }

    svg {
      cursor: pointer;
    }
  }

  footer {
    display: flex;
    gap: 0.75rem;
    justify-content: flex-end;
    margin-top: 0.5rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;

  p {
    margin: 0;
    font-size: 0.875rem;
    font-weight: 600;
  }
`;
